import { render } from "./AcceptedMaterials.vue?vue&type=template&id=7638ca75"
import script from "./AcceptedMaterials.vue?vue&type=script&lang=js"
export * from "./AcceptedMaterials.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__